import styles from "./EmergencyInfoPopup.scss";
import { getLocalizedStrings } from "./popupLocalizedStrings";


function EmergencyInfoPopup(props) {

  let emergencyStrings = getLocalizedStrings("EmergencyAlerts");
  return (
    <div>
      <div className={styles.popUp}>
        <div className={styles.popupContent}>
          {props.infoPopupTxt}
        </div>
      </div>
    </div>
  );
}

export default EmergencyInfoPopup;